// extracted by mini-css-extract-plugin
export var currencyInput = "_n6-1";
export var currencySymbol = "_n6-0";